import $ from 'jquery';

import 'slick-carousel';

export function initMonthSlider() {
    $('.event-calendar .months').slick({
        infinite: true, slidesToShow: 3, slidesToScroll: 1, arrows: true, responsive: [{
            breakpoint: 992, settings: {
                slidesToShow: 2, slidesToScroll: 2,
            }
        }, {
            breakpoint: 768, settings: {
                slidesToShow: 2, slidesToScroll: 2
            }
        }, {
            breakpoint: 420, settings: {
                slidesToShow: 1, slidesToScroll: 1
            }
        }]
    });

    $(".months .slick-arrow").text("");
}
